export const truncate = (word, maxLength, suffix = '...') => {
  if (word?.length > maxLength) {
    return `${word?.slice(0, maxLength - 1)} ${suffix}`;
  } else {
    return word;
  }
};
